import { LoadingOutlined } from "@ant-design/icons";
import { notification, Spin } from "antd";
import { Field, Form, Formik } from "formik";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import { editConfigValidation } from "utils/validations";

import CloseModal from "../../../components/icons/CloseModal";
const EditTemplateConfig = (props) => {
  const { open, onClose: handleClose, onSubmit: handleSubmit, fetchTemplateConfig } = props;
  const [load, setLoad] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [templateConfigData, setTemplateConfigData] = useState({ minBitrate: "" });
  useEffect(() => {
    if (templateConfigData)
      setInitialValues({ minBitrate: templateConfigData?.videoTemplateConfiguration?.minBitrate });
  }, [templateConfigData]);

  const getTemplateConfig = async () => {
    const response = await fetchTemplateConfig();
    if (response.value.status) {
      setTemplateConfigData(response.value.data);
    } else {
      notification["error"]({ message: "Something went wrong" });
    }
  };
  useEffect(() => {
    if (open) getTemplateConfig();
  }, [open]);
  const handleFormSubmit = async (values) => {
    setLoad(true);
    const payload = {
      configType: "videoTemplateConfig",
      videoTemplateConfiguration: {
        minBitrate: values.minBitrate,
      },
    };
    const response = await handleSubmit(payload);

    if (response.value.status) {
      notification["success"]({ message: "Template config updated successfully" });
      setLoad(false);
      handleClose();
    } else {
      notification["error"]({ message: "Something went wrong" });
    }
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick={false}
      overlayClassName="modal"
      className="modal-dialog react-modal-dialog-xm modal-dialog-centered"
    >
      <div className="modal-content">
        <div className="react-modal-header">
          <h5 className="react-modal-title">Edit Template Configuration</h5>
          <button type="button" onClick={handleClose} className="btn btn__default">
            <CloseModal />
          </button>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={editConfigValidation}
          enableReinitialize
          onSubmit={handleFormSubmit}
        >
          {({ errors, touched, setFieldValue, values }) => (
            <Form>
              <div className="react-modal-body">
                <div className="form-container">
                  <div className="form-group">
                    <label className="form-label">Minimum Bitrate</label>
                    <Field className="form-control" name="minBitrate" type="number" placeholder="Enter Min Bitrate" />
                    {touched.minBitrate && errors.minBitrate && (
                      <div className="invalid-feedback">{errors.minBitrate}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="react-modal-footer">
                <div className="react-foo-container">
                  <div className="right-btn-block text-center">
                    <button type="button" className="btn btn-white" onClick={handleClose}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Edit
                      {load && (
                        <Spin
                          size="large"
                          indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                          className="loader__full"
                        ></Spin>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};
export default EditTemplateConfig;
